<bb-card-loading *ngIf="loading"></bb-card-loading>
<ng-container *ngIf="!!timecards">
    <span class="information-message">The selected date does not affect this information.</span>
    <ion-list>
        <ion-item *ngIf="timecards.length === 0">
            There are no flagged timecards.
        </ion-item>
        <ion-item *ngFor="let timecard of timecards; trackBy: getId" class="pointer" (click)="editTimecard(timecard)">
            <ion-label>
                {{ timecard.person.name }}
                <p>{{ timecard.clockInTime | date:'short' }}</p>
                <p *ngIf="!!timecard.pickupLocation">{{ timecard.pickupLocation.name }}</p>
            </ion-label>
            <div class="ion-text-center" slot="end">
                {{ formatTotalTime(timecard) }}
                <ion-text *ngIf="timecard.tipped" color="success">
                    <p>Tipped</p>
                </ion-text>
            </div>
        </ion-item>
    </ion-list>

    <ion-item *ngIf="!loading && error">
        <ion-text color="danger">Could not load data.</ion-text>
    </ion-item>
</ng-container>
